<template>
  <div v-show="isShow" class="custom-mark-title-dialog">
    <button @click="handleClose" class="close-btn">
      <img src="../../../../../assets/images/icon/close.png" alt="" />
    </button>
    <p class="title">自定义标记</p>
    <div class="input-wrap">
      <el-input
        class="mark-title-input"
        type="text"
        placeholder="请填写标记内容"
        v-model.trim="text"
        maxlength="10"
        show-word-limit
      >
      </el-input>
      <button
        v-preventReClick
        @click="handleSave"
        class="save-btn"
        :class="{
          'save-btn__active': text.length,
        }"
      >
        保存
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: "",
      isShow: false,
    };
  },
  methods: {
    handleClose() {
      this.isShow = false;
      this.text = "";
    },
    handleShow() {
      this.isShow = true;
    },
    handleSave() {
      if (this.text.length) {
        this.$emit("save", this.text);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.custom-mark-title-dialog {
  width: 284px;
  height: 62px;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #f2f3f5;
  position: relative;
  .close-btn {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 20px;
    height: 20px;
  }
  .title {
    font-weight: 400;
    font-size: 12px;
    color: #0d1400;
    line-height: 17px;
    padding: 8px 0 3px 8px;
  }
  .input-wrap {
    display: flex;
    align-items: center;
  }
  .mark-title-input {
    margin-right: 5px;
    width: 209px;
    margin-left: 6px;
  }
  ::v-deep .el-input__inner {
    border-radius: 6px;
    border: 1px solid #f2f3f5;
    color: #0d1400;
    height: 28px;
    padding: 0 4px;
  }
  ::v-deep .el-input__inner::placeholder {
    font-size: 12px;
    color: #c9cdd4;
  }
  ::v-deep .el-input__count {
    font-size: 12px;
    color: #c9cdd4;
  }
  .save-btn {
    width: 54px;
    height: 28px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #f2f3f5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #c9cdd4;
    line-height: 1;
  }
  .save-btn__active {
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    border: none;
    color: #ffffff;
    font-weight: 500;
  }
}
</style>
